module.exports = __webpack_public_path__ + "img/jet6_05.267d3697.jpg";